/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M3.7508 6.9895a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM12.0008 6.2395a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2ZM6.75 13a.75.75 0 0 1 .75.75c0 .9665.7834 1.75 1.75 1.75.9664 0 1.7499-.7835 1.7499-1.75a.75.75 0 0 1 1.5 0c0 1.7949-1.455 3.25-3.25 3.25C7.455 17 6 15.5449 6 13.75a.75.75 0 0 1 .75-.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5008 2.7287c0-1.6402-1.4369-2.9096-3.0646-2.7075a50.1916 50.1916 0 0 1-12.3709 0C1.4376-.181.0008 1.0885.0008 2.7287L-.0001 12.25c0 4.8162 3.681 8.7728 8.383 9.2099C10.0407 23.0334 12.2832 24 14.75 24c5.1086 0 9.25-4.1414 9.25-9.25l.0008-9.6708c0-.8916-.7645-1.5913-1.6526-1.5127l-2.533.2244a7.513 7.513 0 0 1-1.3144.001V2.7287ZM22.5 14.7657l.0008-9.6865a.0204.0204 0 0 0-.0012-.0073s-.0023-.004-.0049-.0064a.0303.0303 0 0 0-.0068-.0043s-.0029-.001-.0074-.0005l-2.533.2243a9.0127 9.0127 0 0 1-1.4467.0116l-.0009 6.9534c0 4.6026-3.3616 8.4201-7.7636 9.1312 1.1708.7103 2.5441 1.1188 4.0137 1.1188 4.275 0 7.7415-3.4613 7.75-7.7343Zm-6.8789-13.256c.7328-.091 1.3797.4806 1.3797 1.219l-.0009 9.5213c0 4.2802-3.4698 7.75-7.75 7.75S1.5 16.5302 1.5 12.25l.0009-9.5213c0-.7384.6469-1.31 1.3797-1.219 4.2306.5254 8.51.5254 12.7406 0Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuRoles'
);
